import { PropsWithChildren, useRef, useState } from 'react';

import { RadioFilter, Pill } from '@hapvida/hapvida-core-components';

import newUseFilterParams from '@hapvida/hapvida-core-components/src/hooks/newUseFilterParams';

import { COMPANY_USER_REGISTER_STATUS_DATA } from '@services/CompanySetupService/dtos/ListCompanyDTO';

import type {
  FiltersDrawerButtonProps,
  IFilterOptions,
  TFilterValue,
} from './types';
import { FilterDrawerBase } from '../FilterDrawerBase';
import { formatObjectToFilterUrl } from '../FilterDrawerBase/utils/formatObjectToFilterUrl';

export function NewFilterDrawerCompanySetup({
  subtitle,
  title,
  ...buttonProps
}: PropsWithChildren<FiltersDrawerButtonProps>) {
  const [visibleDrawer, setVisibleDrawer] = useState(false);
  const { changeMultiple } = newUseFilterParams({});

  const handleToggleDrawer = () => {
    setVisibleDrawer(!visibleDrawer);
  };

  const refs: IFilterOptions = {
    status: useRef(null),
  };

  const handleApplyAll = () => {
    let inputsValueObj: TFilterValue = {};

    Object.keys(refs).forEach(key => {
      const ref = refs[key];

      if (ref?.current) {
        inputsValueObj = { ...inputsValueObj, ...ref.current?.filterValue };
      }
    });

    const objectFilterValues = { ...inputsValueObj };

    changeMultiple(formatObjectToFilterUrl(objectFilterValues));
    handleToggleDrawer();
  };

  const companyStatusFilters =
    Object.entries(COMPANY_USER_REGISTER_STATUS_DATA).map(([key, value]) => {
      return {
        label: value.text,
        value: key,
        content: <Pill fitContent text={value.text} color={value.color} />,
      };
    }) ?? [];

  return (
    <FilterDrawerBase
      title={title}
      subtitle={subtitle}
      handleApplyAll={handleApplyAll}
      {...buttonProps}
    >
      <RadioFilter
        name="status"
        title="Status da empresa"
        optionList={companyStatusFilters}
        ref={refs.status}
      />
    </FilterDrawerBase>
  );
}
